import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Sheet } from '@getgrover/ui';
import { Portal } from 'react-portal';
import ScrollLock from 'react-scrolllock-configurable';
import { CartContent, OverlayContainer, OverlayContent, OverlayShadow } from './styled';

const Mobile = ({ className, shouldShow, hideOverlay, isMobile }) => {
    const onCloseSheetBySwipe = useCallback(() => {
        if (shouldShow) {
            hideOverlay();
        }
    }, [shouldShow, hideOverlay]);

    return (
        <Portal>
            <Sheet
                shouldOpen={shouldShow}
                thresholdPercent={isMobile ? 0.2 : 0.6}
                onCloseSheet={onCloseSheetBySwipe}
                overrides={{
                    Container: { component: OverlayContainer },
                    Content: { component: OverlayContent },
                    Shadow: { component: OverlayShadow },
                }}
            >
                <ScrollLock isActive={shouldShow} />
                <CartContent
                    className={className}
                    clickOutside={hideOverlay}
                    shouldShow={shouldShow}
                />
            </Sheet>
        </Portal>
    );
};

Mobile.propTypes = {
    className: PropTypes.string,
    shouldShow: PropTypes.bool,
    hideOverlay: PropTypes.func,
    isMobile: PropTypes.bool.isRequired,
};

Mobile.defaultProps = {
    className: '',
    shouldShow: false,
    hideOverlay: () => {},
};

export default Mobile;
